/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Stack } from "@mui/material";
import ReleaseInfo from "@/src/components/ReleaseInfo/ReleaseInfo";
import React, { ReactNode, useRef } from "react";
import Footer from "@/src/components/Footer/Footer";
import Sidebar from "@/src/components/Sidebar/Sidebar";
import AuthenticatedNavigation from "@/src/components/AuthenticatedNavigation/AuthenticatedNavigation";
import Container, { ContainerProps } from "@/src/components/Container/Container";
import SkipLink from "@/src/components/SkipLink/SkipLink";
import ScrollTopButton from "@/src/components/Button/ScrollTopButton";
import { layoutAuthenticatedStyle } from "@/src/containers/Layouts/layoutAuthenticatedStyle";
import Header from "@/src/components/Header/Header";
import HeaderActionsAuthenticated from "@/src/components/HeaderActionsAuthenticated/HeaderActionsAuthenticated";

export type LayoutAuthenticatedProps = {
  children: ReactNode;
  sidebar?: boolean;
  containerVariant?: ContainerProps["variant"];
};

export default function LayoutAuthenticated({ children, sidebar = true, containerVariant = "md" }: LayoutAuthenticatedProps) {
  const skipLinkRef = useRef<HTMLAnchorElement>(null);

  return (
    <>
      <ReleaseInfo />
      <SkipLink ref={skipLinkRef} />
      <Header
        logoLink={{ label: "Zur Servicewelt", to: "/servicewelt" }}
        actions={<HeaderActionsAuthenticated />}
        mobileNavComp={<AuthenticatedNavigation sx={layoutAuthenticatedStyle.navigationMobile} />}
      />
      <Stack direction={"row"}>
        {sidebar && (
          <Sidebar sx={layoutAuthenticatedStyle.sidebar}>
            <AuthenticatedNavigation sx={layoutAuthenticatedStyle.navigation} />
          </Sidebar>
        )}
        <Box sx={layoutAuthenticatedStyle.pageContainer}>
          <Box component={"main"} id={"main-content"} sx={layoutAuthenticatedStyle.childrenContainer}>
            <Container variant={containerVariant}>{children}</Container>
          </Box>
          <ScrollTopButton skipLinkRef={skipLinkRef} />
          <Footer variant={"loggedIn"} />
        </Box>
      </Stack>
    </>
  );
}
